module.exports = __webpack_public_path__ + "img/wa-background.756286e6.jpg";